export const getCanvasBase64 = (canvasRef) => {
    const canvas = canvasRef.current;
    return canvas.toDataURL();
}